import React, { useEffect, useState } from 'react';
import { X } from 'lucide-react';
import { useI18n } from '../context/I18nContext';

export default function CookieBanner() {
  const { t } = useI18n();
  const [visible, setVisible] = useState(false);

  // Show on every page load (no persistent storage)
  useEffect(() => {
    const id = setTimeout(() => setVisible(true), 500);
    return () => clearTimeout(id);
  }, []);

  if (!visible) return null;

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-[60] bg-[#05150f]/95 backdrop-blur-md border-t border-[#c9a961]/30 shadow-2xl"
      data-testid="cookie-banner"
    >
      <div className="max-w-[1440px] mx-auto px-6 lg:px-12 py-5 flex flex-col md:flex-row items-start md:items-center gap-5">
        <div className="flex-1">
          <p className="font-serif text-base text-[#f5f5f0] mb-1">{t('cookie.title')}</p>
          <p className="text-sm text-[#a3b5ad] font-light leading-relaxed">{t('cookie.body')}</p>
        </div>
        <div className="flex items-center gap-3 flex-shrink-0">
          <button
            onClick={() => setVisible(false)}
            className="px-4 py-2 text-xs tracking-[0.2em] uppercase text-[#a3b5ad] hover:text-[#f5f5f0] transition-colors border border-[#c9a961]/30 hover:border-[#c9a961]/60"
            data-testid="cookie-decline"
          >
            {t('cookie.decline')}
          </button>
          <button
            onClick={() => setVisible(false)}
            className="gn-btn-primary"
            data-testid="cookie-accept"
            style={{ padding: '0.6rem 1.5rem', fontSize: '0.72rem' }}
          >
            {t('cookie.accept')}
          </button>
          <button
            onClick={() => setVisible(false)}
            className="text-[#a3b5ad] hover:text-[#c9a961] lg:hidden"
            aria-label="Close"
            data-testid="cookie-close"
          >
            <X size={18} />
          </button>
        </div>
      </div>
    </div>
  );
}
